import httpService from "./httpService";
import utils from "./utils";

export default {

	findAll(example, pagable) {
		pagable = utils.initPageableParams(pagable);
		let params = utils.merge(example, pagable);
		return httpService.get("/groups", {params: params});
	},

	findById(id) {
		return httpService.get("groups/" + id);
	},

	save(form) {
		return httpService.post(`groups`, form);
	},

	remove(id) {
		return httpService.delete(`groups/${id}`);
	},

	update(id, form) {
		return httpService.put(`/groups/${id}`, form);
	},
	userDeptInGroup(id) {
		return httpService.get(`/groups/userDeptInGroup/${id}`, null);
	},


}



// WEBPACK FOOTER //
// ./src/services/groupsService.js